import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantities, answer) {
    return getLayout(width, height, settings, quantities, answer)
}

function getLayout(width, height, settings, quantities, answer) {
    if (settings.position === 'horizontal') {
        return getHorizontalLayout(width, height, settings, quantities, answer)
    } else {
        return getVerticalLayout(width, height, settings, quantities, answer)
    }
}

function getHorizontalLayout(width, height, settings, quantities, answer) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        dotSize,
        marginBottom,
        lineWeight,
        fontSize
    } = getLayoutSettings(width, height)

    const spaced = settings.spaced
    const dotsSpaceSize = spaced ? dotSize : 0
    const dotsWidth = (quantities.value_1 + quantities.value_2) * dotSize + dotsSpaceSize

    const dotsMargin = (gameContainerWidth - dotsWidth) / 2 + dotSize / 2

    const colour1 = settings.value_1_colour || 'silver'
    const colour2 = settings.value_2_colour || 'silver'
    let dotsFirst = []
    let dotsSecond = []

    let lineWidth = gameContainerWidth / 20
    let line = utils.getLine(0, gameContainerHeight / 2, lineWidth, 20)


    for (let i = 0; i < quantities.value_1; i++) {
        dotsFirst.push(
            utils.getBoltWithLine(dotsMargin + dotSize * i, gameContainerHeight / 2, dotSize, lineWidth, colour1)
        )
    }

    for (let i = quantities.value_1; i < quantities.value_1 + quantities.value_2; i++) {
        let index = spaced ? i + 1: i
        dotsSecond.push(
            utils.getBoltWithLine(dotsMargin + dotSize * index, gameContainerHeight / 2, dotSize, lineWidth, colour2)
        )
    }

    let labelsLayout = null

    if (settings.show_labels) {
        labelsLayout = (
            <g>
                <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    x={dotsMargin + quantities.value_1 * dotSize / 2 - dotSize / 2}
                    y={gameContainerHeight / 2  - dotSize}
                    textAnchor="middle"
                >{quantities.value_1}</text>
                <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    x={dotsMargin + dotsWidth - quantities.value_2 * dotSize / 2 - dotSize / 2}
                    y={gameContainerHeight / 2  - dotSize}
                    textAnchor="middle"
                >{quantities.value_2}</text>
            </g>
        )

    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {line.map(value => {
                return value
            })}
            {dotsFirst.map(value => {
                return value
            })}
            {dotsSecond.map(value => {
                return value
            })}
            {labelsLayout}
        </svg>
    )
}

function getVerticalLayout(width, height, settings, quantities, answer) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        dotSize,
        marginBottom,
        lineWeight,
        fontSize
    } = getLayoutSettings(width, height)

    const spaced = settings.spaced
    const dotsWidth1 = quantities.value_1 * dotSize
    const dotsWidth2 = quantities.value_2 * dotSize
    
    const dotsMargin1 = dotSize / 2//(gameContainerWidth - dotsWidth1) / 2 + dotSize / 2
    const dotsMargin2 = dotSize / 2//(gameContainerWidth - dotsWidth2) / 2 + dotSize / 2

    const colour1 = settings.value_1_colour || 'silver'
    const colour2 = settings.value_2_colour || 'silver'
    let dotsFirst = []
    let dotsSecond = []
    let lineWidth = gameContainerWidth / 20
    let line1 = utils.getLine(0, gameContainerHeight / 4, lineWidth, 20)
    let line2 = utils.getLine(0, gameContainerHeight / 4 * 3, lineWidth, 20)


    for (let i = 0; i < quantities.value_1; i++) {
        dotsFirst.push(
            utils.getBoltWithLine(dotsMargin1 + dotSize * i, gameContainerHeight / 4, dotSize, lineWidth, colour1)
        )
    }

    for (let i = 0; i < quantities.value_2; i++) {
        dotsSecond.push(
            utils.getBoltWithLine(dotsMargin2 + dotSize * i, gameContainerHeight / 4 * 3, dotSize, lineWidth, colour2)
        )
    }

    let labelsLayout = null

    if (settings.show_labels) {
        labelsLayout = (
            <g>
                <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    x={gameContainerWidth / 2}
                    y={gameContainerHeight / 4 - dotSize}
                    textAnchor="middle"
                >{quantities.value_1}</text>
                <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    x={gameContainerWidth / 2}
                    y={gameContainerHeight / 4 * 3 - dotSize}
                    textAnchor="middle"
                >{quantities.value_2}</text>
            </g>
        )

    }

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}
        >
            {line1.map(value => {
                return value
            })}
            {line2.map(value => {
                return value
            })}

            {dotsFirst.map(value => {
                return value
            })}
            {dotsSecond.map(value => {
                return value
            })}
            {labelsLayout}
        </svg>
    )
}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {

    /* const gameContainerMargin = gameContainerWidth * .04

    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const sideMargin = gameContainerWidth * .2

    const dotSize = gameContainerWidth / 10
    const marginBottom = gameContainerWidth * .1
    const lineWeight = gameContainerWidth / 150
    const fontSize = gameContainerWidth / 15

    return {
        gameContainerWidth,
        gameContainerHeight,
        sideMargin,
        dotSize,
        marginBottom,
        lineWeight,
        fontSize
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/beadStringPair.utils.js